import { defineMessages } from 'react-intl';

export const scope = 'app.components.AgeGroupBucketSettings';

export const messages = defineMessages({
  loading: { id: `${scope}.loading`, defaultMessage: 'Loading…' },
  intro: {
    id: `${scope}.intro`,
    defaultMessage: 'An age group scores against the seed weights of its bucket. A row with no bucket scores nothing until one is set here.',
  },
  loadError: {
    id: `${scope}.loadError`,
    defaultMessage: 'Couldn’t load age groups. Please refresh and try again.',
  },
  noAssessment: { id: `${scope}.noAssessment`, defaultMessage: 'Choose an assessment to set its age-group buckets.' },
  noAgeGroups: { id: `${scope}.noAgeGroups`, defaultMessage: 'This assessment has no age groups yet.' },
  noOptions: {
    id: `${scope}.noOptions`,
    defaultMessage: 'No buckets are available — no seed weights are configured.',
  },
  bucketLabel: { id: `${scope}.bucketLabel`, defaultMessage: 'Bucket' },
  noBucket: { id: `${scope}.noBucket`, defaultMessage: 'No bucket' },
  retiredBucket: { id: `${scope}.retiredBucket`, defaultMessage: '{bucket} (no seed weights)' },
  matchedNearest: { id: `${scope}.matchedNearest`, defaultMessage: 'Nearest match' },
  matchedNone: { id: `${scope}.matchedNone`, defaultMessage: 'Needs a bucket' },
  manual: { id: `${scope}.manual`, defaultMessage: 'Set manually' },
  clearedBucket: { id: `${scope}.clearedBucket`, defaultMessage: 'Cleared — scores nothing' },
  rematch: { id: `${scope}.rematch`, defaultMessage: 'Matcher now suggests {bucket}' },
  confirmClearTitle: { id: `${scope}.confirmClearTitle`, defaultMessage: 'Clear the bucket for "{name}"?' },
  confirmClearBody: {
    id: `${scope}.confirmClearBody`,
    defaultMessage: 'Without a bucket, "{name}" scores nothing, and the weights seeded from {bucket} are removed.',
  },
  confirmClear: { id: `${scope}.confirmClear`, defaultMessage: 'Clear bucket' },
  cancel: { id: `${scope}.cancel`, defaultMessage: 'Cancel' },
  saveError: {
    id: `${scope}.saveError`,
    defaultMessage: 'Couldn’t change the bucket for "{name}". Please try again.',
  },
});
